import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { PhotoCarousel } from './components/PhotoCarousel';
import { Intro } from './components/Intro';
import { Experience } from './components/Experience';
import { House } from './components/House';
import { Discover } from './components/Discover';
import { WhyStay } from './components/WhyStay';
import { LocationSection } from './components/LocationSection';
import { Reviews } from './components/Reviews';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { BookingBar } from './components/BookingBar';
import { WhatsAppButton } from './components/WhatsAppButton';
export function App() {
  return <div className="w-full bg-ivory" data-id="element-0" data-mp="28ufpyg1ohml6">
      <Header data-id="element-1" data-mp="28te1n9vnj3li" />
      <main data-id="element-2" data-mp="28suumo7jhzm9">
        <Hero data-id="element-3" data-mp="28sl511qepuh3" />
        <PhotoCarousel data-id="element-4" data-mp="28s2x37udtrtc" />
        <Intro data-id="element-5" data-mp="23vkzqt1dsvr1" />
        <Experience data-id="element-6" data-mp="23w4ey1znd61d" />
        <House data-id="element-7" data-mp="23ujha3i1d6za" />
        <Reviews data-id="element-8" data-mp="23v2td3l0915e" />
        <Discover data-id="element-9" data-mp="23ti67z10skhk" />
        <WhyStay data-id="element-10" data-mp="3ik7k0rkruvvx" />
        <LocationSection data-id="element-11" data-mp="3ikqwvtvkeu33" />
        <Faq data-id="element-12" data-mp="3ijfu9xduvsdk" />
        <FinalCta data-id="element-13" data-mp="3ihv2gfixenje" />
      </main>
      <Footer data-id="element-14" data-mp="3mlayb9n68jv1" />
      <BookingBar data-id="element-15" data-mp="3mkre1ma1tjdu" />
      <WhatsAppButton data-id="element-16" data-mp="3mk868ye44bdj" />
    </div>;
}